import Big from 'big.js';

const PRICE_DECIMALS = 2;
const PERCENTAGE_DECIMALS = 4;
const RATE_DECIMALS = 6;

export const roundPrice = (value: Big.BigSource): number =>
  Big(value).round(PRICE_DECIMALS).toNumber();

export const roundPercentage = (value: Big.BigSource): number =>
  Big(value).round(PERCENTAGE_DECIMALS).toNumber();

export const rateToPercentage = (rate: number): number =>
  roundPercentage(Big(rate).times(100));

export const percentageToRate = (percentage: number): number =>
  Big(percentage).div(100).round(RATE_DECIMALS).toNumber();

export const applyDiscountRate = (
  unitPrice: Big.BigSource,
  rate: number | null | undefined
): number => roundPrice(Big(unitPrice).times(Big(1).minus(rate ?? 0)));

export const multiplyPrice = (price: number, quantity: number): number =>
  Big(price).times(quantity).toNumber();

export const sumPrices = (prices: number[]): number =>
  prices.reduce((total, price) => total.plus(price), Big(0)).toNumber();
